import { createContext, Dispatch, useContext } from "react";

import { ActionPayload, BaseInitialState } from "./types";

interface FlowContainerContextProps<TData = unknown> {
  state: BaseInitialState<TData>;
  dispatch: Dispatch<ActionPayload<TData>>;
}

const FlowContainerContext = createContext<
  FlowContainerContextProps | undefined
>(undefined);

export function useFlowContainerContext<TData = unknown>() {
  const context = useContext(FlowContainerContext) as
    | FlowContainerContextProps<TData>
    | undefined;

  if (context === undefined) {
    throw new Error(
      "[Farther Exception] FlowContainer context must be used within a FlowContainerContext.Provider"
    );
  }

  return context;
}

export default FlowContainerContext;
